import { render, staticRenderFns } from "./demo_contractManage_new.vue?vue&type=template&id=afff9000&scoped=true&"
import script from "./demo_contractManage_new.vue?vue&type=script&lang=js&"
export * from "./demo_contractManage_new.vue?vue&type=script&lang=js&"
import style0 from "./demo_contractManage_new.vue?vue&type=style&index=0&lang=less&"
import style1 from "./demo_contractManage_new.vue?vue&type=style&index=1&id=afff9000&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afff9000",
  null
  
)

export default component.exports